import React from 'react';
import { useTranslation } from '../../i18n/useTranslation';
import './Hero.css';

const Hero = () => {
  const { t } = useTranslation();

  const scrollTo = (id) => {
    document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section className="hero">
      <div className="hero__bg">
        <div className="hero__overlay"></div>
        <div className="hero__pattern"></div>
      </div>

      <div className="container hero__container">
        <div className="hero__content">
          <div className="hero__badge">{t('hero.badge')}</div>
          <h1 className="hero__title">
            {t('hero.title1')}
            <span className="hero__title-accent">{t('hero.titleAccent')}</span>
            <br />{t('hero.title2')}
          </h1>
          <p className="hero__text">{t('hero.text')}</p>

          <div className="hero__stats">
            <div className="hero__stat">
              <span className="hero__stat-number">{t('hero.stat1num')}</span>
              <span className="hero__stat-label">{t('hero.stat1label')}</span>
            </div>
            <div className="hero__stat">
              <span className="hero__stat-number">{t('hero.stat2num')}</span>
              <span className="hero__stat-label">{t('hero.stat2label')}</span>
            </div>
            <div className="hero__stat">
              <span className="hero__stat-number">{t('hero.stat3num')}</span>
              <span className="hero__stat-label">{t('hero.stat3label')}</span>
            </div>
          </div>

          <div className="hero__buttons">
            <button className="btn btn-primary btn-lg" onClick={() => scrollTo('booking')}>
              {t('hero.btnBooking')}
            </button>
            <button className="btn btn-outline btn-lg" onClick={() => scrollTo('prices')}>
              {t('hero.btnPrices')}
            </button>
          </div>
        </div>

        <div className="hero__visual">
          <div className="hero__card hero__card--1">
            <span className="hero__card-icon">✅</span>
            <div>
              <div className="hero__card-title">{t('hero.card1title')}</div>
              <div className="hero__card-text">{t('hero.card1text')}</div>
            </div>
          </div>
          <div className="hero__card hero__card--2">
            <span className="hero__card-icon">🔧</span>
            <div>
              <div className="hero__card-title">{t('hero.card2title')}</div>
              <div className="hero__card-text">{t('hero.card2text')}</div>
            </div>
          </div>
          <div className="hero__card hero__card--3">
            <span className="hero__card-icon">⏰</span>
            <div>
              <div className="hero__card-title">{t('hero.card3title')}</div>
              <div className="hero__card-text">{t('hero.card3text')}</div>
            </div>
          </div>
        </div>
      </div>

      <div className="hero__scroll-hint" onClick={() => scrollTo('services')}>
        <span>↓</span>
      </div>
    </section>
  );
};

export default Hero;